import {
  ElementActionTypes,
  IDeleteElementPayload,
  IFetchElementsSuccessResponseBody,
  ISubmitUrlsPayload,
  ISubmitUrlsSuccessResponseBody,
  ICreateElementSuccessResponseBody,
  ICreateElementPayload,
  IFetchElementsPayload,
} from './types'

export const fetchElements = (payload: IFetchElementsPayload) => ({
  type: ElementActionTypes.FETCH_ELEMENTS,
  payload
})

export const fetchElementsSuccess = (payload: IFetchElementsSuccessResponseBody) => ({
  type: ElementActionTypes.FETCH_ELEMENTS_SUCCESS,
  payload,
})

export const fetchElementsFailure = () => ({
  type: ElementActionTypes.FETCH_ELEMENTS_FAILURE
})

export const deleteElement = (payload: IDeleteElementPayload) => ({
  type: ElementActionTypes.DELETE_ELEMENT,
  payload
})

export const deleteElementSuccess = (payload: IDeleteElementPayload) => ({
  type: ElementActionTypes.DELETE_ELEMENT_SUCCESS,
  payload
})

export const deleteElementFailure = () => ({
  type: ElementActionTypes.DELETE_ELEMENT_FAILURE,
})

export const createElement = (payload: ICreateElementPayload) => ({
  type: ElementActionTypes.CREATE_ELEMENT,
  payload
})

export const createElementFailure = () => ({
  type: ElementActionTypes.CREATE_ELEMENT_FAILURE,
})

export const createElementSuccess = (payload: ICreateElementSuccessResponseBody) => ({
  type: ElementActionTypes.CREATE_ELEMENT_SUCCESS,
  payload
})

export const submitUrls = (payload: ISubmitUrlsPayload) => ({
  type: ElementActionTypes.SUBMIT_URLS,
  payload
})

export const submitUrlsSuccess = (payload: ISubmitUrlsSuccessResponseBody) => ({
  type: ElementActionTypes.SUBMIT_URLS_SUCCESS,
  payload
})

export const submitUrlsFailure = () => ({
  type: ElementActionTypes.SUBMIT_URLS_FAILURE,
})

export const resetShouldCheckAutoFill = () => ({
  type: ElementActionTypes.RESET_SHOULD_CHECK_AUTO_FILL,
})

export const setShouldCheckAutoFill = () => ({
  type: ElementActionTypes.SET_SHOULD_CHECK_AUTO_FILL,
})
